module.exports = __webpack_public_path__ + "static/media/lunbo6.09bd75b7.png";